import { Map as IMap } from 'immutable';
import {
    take, select, call, put
} from 'redux-saga/effects';
import { RETRIEVED_BRAND_CONFIG } from 'capi/redux';

import { isPaypalEnabled, getPaypalClientID } from '../brand/brandSelectors';
import { getPaypalLocaleCode } from './paypalSelectors';



export const PAYPAL_LOADED = '@@storefront/PAYPAL_LOADED';

const initialState = IMap({ paypalLoaded: false });

export const paypalReducer = (state = initialState, action) => {
    switch (action.type) {
        
        case PAYPAL_LOADED: {
            return state.set('paypalLoaded', true);
        }
        default:
    }
    return state;
};


export const paypalLoaded = () => ({
    type: PAYPAL_LOADED
});


export const getPaypalLoaded = state => state.getIn(['paypal', 'paypalLoaded']);


export const loadPaypal = (paypalId, localeCode) => new Promise((resolve) => {
    const script = document.createElement('script');
    script.setAttribute('src', `https://www.paypal.com/sdk/js?client-id=${paypalId}&locale=${localeCode}&currency=USD&commit=true&vault=true&intent=authorize&disable-funding=credit,card&integration-date=2020-05-19`);
    
    script.onreadystatechange = script.onload = () => {
        resolve(window.paypal);
    };
    document.getElementsByTagName('head')[0].appendChild(script);
});


export const importPayPalLocaleMap = async () => import('./data/paypalLocaleMap');


export function* paypalLoaderSaga() {
    
    while (true) {
        yield take(RETRIEVED_BRAND_CONFIG.PAYMENT);
        const paypalIsEnabled = yield select(isPaypalEnabled);
        const paypalIsLoaded = yield select(getPaypalLoaded);
        const payPalLocaleMap = (yield call(importPayPalLocaleMap)).default;
        const localeCode = (yield select(getPaypalLocaleCode))(payPalLocaleMap);
        const paypalId = yield select(getPaypalClientID);

        if (paypalIsEnabled && !paypalIsLoaded) {
            yield call(loadPaypal, paypalId, localeCode);
            yield put(paypalLoaded());
        }
    }
}
